import { AnchorGroup } from "@/components/anchors-navigation";
import FilterButton from "@/components/filtering/Button";
import { useWindowSize } from "@/hooks";
import { ChevronLeftIcon } from "@heroicons/react/24/outline";
import { useLayoutEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

const ElementLoading = () => {
    const [width] = useWindowSize();
    const [left, setLeft] = useState(0);

    const params = useParams();
    const { t } = useTranslation("elements");

    useLayoutEffect(() => {
        if (width === 2560) {
            setLeft(0);
        } else {
            const change = 2560 - width;
            setLeft(change * -0.5);
        }
    }, [width]);

    return (
        <>
            <div
                className={`absolute w-full h-full bg-primary-100 overflow-hidden`}
                style={{
                    left: `${left}px`,
                    width: 2015,
                    clipPath: "polygon(200px 0, 2015px 0, 838px 450px)",
                }}
            />

            <div className="container mx-auto 2xl:px-[108px]">
                <section id="hero" className="relative pt-[60px] mb-1">
                    <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4 mb-4">
                        <div className="flex flex-col mt-3">
                            <Link
                                to={`/${params.locale}/elements`}
                                className="flex w-fit items-center gap-2 mb-4 text-primary-500 hover:text-primary-600 hover:underline select-none cursor-pointer"
                            >
                                <ChevronLeftIcon className="w-4 h-4" /> {t("return", { ns: "elements" })}
                            </Link>
                            <div className="animate-pulse">
                                <h1 className="font-bold content-center space-y-4">
                                    <div className="h-6 bg-primary-500 rounded-full w-full"></div>
                                    <div className="h-6 bg-primary-500 rounded-full w-1/3"></div>
                                    {/* <span className="text-primary-500">Armoire protection incendie</span> */}
                                </h1>
                                <div className="text-lg/[32px] font-medium mt-4 max-w-[920px]">
                                    {/* Basé sur la structure IFC - Conforme à la norme IFC (ISO 16739) :{" "} */}
                                    {/* <a className="font-bold text-primary-500 hover:text-primary-600 hover:underline cursor-pointer">
                                    IfcFireSuppressionTerminal
                                </a> */}

                                    <div className="h-2.5 bg-gray-300 rounded-full w-full animate-pulse"></div>
                                    <div className="inline-block h-2.5 bg-gray-300 rounded-full w-1/5 animate-pulse mr-2"></div>
                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-2/5 animate-pulse"></div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="flex items-center justify-center w-full h-[450px] bg-gray-300 rounded-3xl  animate-pulse">
                                <svg
                                    className="w-10 h-10 text-gray-200 dark:text-gray-600"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 18"
                                >
                                    <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </section>
                <main>
                    <div className="relative grid grid-cols-[auto_minmax(100px,1fr)] gap-14">
                        <AnchorGroup>
                            <FilterButton />
                        </AnchorGroup>

                        <div className="py-13 mb-13">
                            <div id="block-1">
                                <h2 className="font-bold text-[45px] text-primary-500">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/2"></div>
                                </div>
                            </div>
                            <div id="block-2" className="mt-5">
                                <table className="font-ibm-sans min-w-full divide-y divide-gray-300 rounded-lg border-separate border-spacing-0 text-[15px]/[20px]">
                                    <thead className="bg-primary-500 text-white font-bold">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l rounded-tl-lg border-primary-600 w-1/3"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/3"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 rounded-tr-lg w-1/3"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white text-black font-medium">
                                        <tr>
                                            <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]"></td>
                                            <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                <div className="h-2.5 bg-gray-200 rounded-full w-1/2 mb-2"></div>
                                                <div className="h-2.5 bg-gray-200 rounded-full w-1/2"></div>
                                            </td>
                                            <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5]"></td>
                                        </tr>
                                        {[0, 1].map((_, index) => (
                                            <tr key={index} className="even:bg-[#F7FAFF] group">
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5] group-last:first:rounded-bl-lg ">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5]  group-last:last:rounded-br-lg">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div id="block-3">
                                <h2 className="font-bold text-[45px] text-primary-500 mt-15">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>

                                <table className="font-ibm-sans min-w-full divide-y divide-gray-300 rounded-lg border-separate border-spacing-0 text-[15px]/[20px]">
                                    <thead className="bg-primary-500 text-white font-bold">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l rounded-tl-lg border-primary-600 w-2/7"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 rounded-tr-lg w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white text-black font-medium">
                                        <tr className="bg-primary-300 text-primary-500">
                                            <td className="border-l border-b border-r border-primary-400" colSpan={6}>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[180px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[200px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        {[0, 1, 2, 3, 4, 5].map((_, index) => (
                                            <tr key={index} className="odd:bg-[#F7FAFF] group">
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5] group-last:first:rounded-bl-lg ">
                                                    <div className="flex">
                                                        <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                        <div className="ml-auto inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                    </div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5]  group-last:last:rounded-br-lg">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>

                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>
                            </div>
                            <div id="block-4">
                                <h2 className="font-bold text-[45px] text-primary-500 mt-15">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>

                                <table className="font-ibm-sans min-w-full divide-y divide-gray-300 rounded-lg border-separate border-spacing-0 text-[15px]/[20px]">
                                    <thead className="bg-primary-500 text-white font-bold">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l rounded-tl-lg border-primary-600 w-3/12"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/12"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/12"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/12"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/12"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 w-1/12"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 w-2/12"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 rounded-tr-lg w-2/12"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white text-black font-medium">
                                        <tr className="bg-primary-300 text-primary-500">
                                            <td className="border-l border-b border-r border-primary-400" colSpan={8}>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[180px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[200px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr className="bg-primary-100 text-primary-500">
                                            <td className="border-l border-b border-r border-primary-300" colSpan={8}>
                                                <div className="inline-block py-3 px-2.5">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[200px] mr-2"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        {[0, 1, 2, 3, 4, 5].map((_, index) => (
                                            <tr key={index} className="odd:bg-[#F7FAFF] group">
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5] group-last:first:rounded-bl-lg ">
                                                    <div className="flex">
                                                        <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                        <div className="ml-auto inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                    </div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5] group-last:last:rounded-br-lg">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div id="block-5">
                                <h2 className="font-bold text-[45px] text-primary-500 mt-15">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>

                                <table className="font-ibm-sans min-w-full divide-y divide-gray-300 rounded-lg border-separate border-spacing-0 text-[15px]/[20px]">
                                    <thead className="bg-primary-500 text-white font-bold">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l rounded-tl-lg border-primary-600 w-2/7"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-primary-600 w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r border-primary-600 rounded-tr-lg w-1/7"
                                            >
                                                <div className="animate-pulse space-y-2 place-items-center">
                                                    <div className="h-3 bg-white rounded-full w-1/4"></div>
                                                    <div className="h-3 bg-white rounded-full w-1/5"></div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white text-black font-medium">
                                        <tr className="bg-primary-300 text-primary-500">
                                            <td className="border-l border-b border-r border-primary-400" colSpan={6}>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[180px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                                <div className="inline-block py-3 px-2.5 border-r border-primary-400">
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[200px] mr-2"></div>
                                                    <div className="inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                </div>
                                            </td>
                                        </tr>
                                        {[0, 1, 2, 3, 4, 5].map((_, index) => (
                                            <tr key={index} className="odd:bg-[#F7FAFF] group">
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5] group-last:first:rounded-bl-lg ">
                                                    <div className="flex">
                                                        <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                        <div className="ml-auto inline-block h-2.5 bg-primary-500 rounded-full w-[20px]"></div>
                                                    </div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5]">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5]  group-last:last:rounded-br-lg">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-[20px] mx-auto"></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div id="block-6">
                                <h2 className="font-bold text-[45px] text-primary-500 mt-15">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>

                                <table className="font-ibm-sans min-w-full divide-y divide-gray-300 rounded-lg border-separate border-spacing-0 text-[15px]/[20px]">
                                    <thead className="bg-primary-500 text-white font-bold">
                                        <tr>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l rounded-tl-lg border-primary-600 w-1/2"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                            <th
                                                scope="col"
                                                className="py-3 px-2.5 text-center border-t border-l border-r rounded-tr-lg border-primary-600 w-1/2"
                                            >
                                                <div className="animate-pulse ">
                                                    <div className="h-3 bg-white rounded-full w-1/3"></div>
                                                </div>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white text-black font-medium">
                                        {[0, 1, 2, 3].map((_, index) => (
                                            <tr key={index} className="odd:bg-[#F7FAFF] group">
                                                <td className="py-3 px-2.5 border-l border-b border-[#E5E5E5] group-last:first:rounded-bl-lg ">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                </td>
                                                <td className="py-3 px-2.5 border-l border-b border-r border-[#E5E5E5] group-last:last:rounded-br-lg">
                                                    <div className="h-2.5 bg-gray-200 rounded-full w-3/4"></div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            <div id="block-7">
                                <h2 className="font-bold text-[45px] text-primary-500 mt-15">
                                    <div className="mt-5 animate-pulse space-y-4">
                                        <div className="h-4 bg-primary-500 rounded-full w-1/4"></div>
                                    </div>
                                </h2>
                                <div className="mt-5 mb-10 animate-pulse space-y-4">
                                    <div className="h-2.5 bg-gray-200 rounded-full w-1/3"></div>
                                </div>
                                {/* <div className="flex w-fit px-7.5 py-5 bg-[#00528B]/15 hover:bg-[#00528B]/25 rounded-lg items-center cursor-pointer text-base/snug text-[#00528B] font-bold">
                                    <TechBimIcon /> <span className="ml-5">Afficher la documentation TechBiM</span>
                                    <ArrowTopRightOnSquareIcon className="ml-1 mb-3 w-4 h-4" />
                                </div> */}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default ElementLoading;
